export default {
    computed: {
        id() {
            return (this.fq.fq_id).toString()
        },
    },
}
